module.exports = __webpack_public_path__ + "static/media/heavy_snow.9386cb04.svg";